import { useState } from "react";
import "./customMultiTable.css";

const CustomMultiTable = ({ title }) => {
  const [activeTab, setActiveTab] = useState(0);

  const tableData = {
    headings: [
      "Phone Number",
      "Address",
      "Customer Type",
      "Email Address",
      "Password",
      "Logo",
      "Created On",
      "Actions",
    ],
    data: [
      {
        phone: "+12505550199",
        address: "5-4658 Barter Street,Canada",
        type: "Designer",
        email: "solarinformatics@gmail.com",
        password: "abc@123",
        created: "29/10/2023, 12:30 AM",
      },
    ],
  };

  for (let i = 0; i < 10; i++) {
    tableData.data.push(tableData.data[0]);
  }

  return (
    <div className="pvxCustomMultiTable">
      <div className="title">
        <span>{title}</span>
        <div className="right">
          <div className="search-box">
            <img
              className="search-icon"
              src="../images/assets/search.png"
              alt="search icon"
            />
            <input
              className="input"
              type="text"
              placeholder="Search by User Name, Date"
            />
          </div>
          <img
            src="./images/PvxDashboard/Icons/Dots.svg"
            className="dots"
            alt="Dots"
          />
        </div>
      </div>

      <div className="tabs">
        <div
          className={activeTab === 0 ? "tab active" : "tab"}
          onClick={()=>setActiveTab(0)}
        >
          Login Requests
        </div>
        <div
          className={activeTab === 1 ? "tab active" : "tab"}
          onClick={()=>setActiveTab(1)}
        >
          Extend Trial Requests
        </div>
        <div
          className={activeTab === 2 ? "tab active" : "tab"}
          onClick={()=>setActiveTab(2)}
        >
          Subscribers
        </div>
      </div>

      <table className="table">
        <thead>
          <tr>
            {tableData.headings.map((heading, index) => (
              <th key={index}>{heading}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {tableData.data.map((row, index) => (
            <tr key={index}>
              <td>{row.phone}</td>
              <td>{row.address}</td>
              <td>{row.type}</td>
              <td>{row.email}</td>
              <td>{row.password}</td>
              <td>
                <div className="logo" />
              </td>
              <td>{row.created}</td>
              <td>
                <div className="actions">
                  {/* Tick */}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                  >
                    <g clip-path="url(#clip0_304_3457)">
                      <path
                        d="M19.7071 2.94916C19.3166 2.55861 18.6835 2.55861 18.2929 2.94916L6.31228 14.9299L1.70713 10.3247C1.31662 9.9342 0.683496 9.93424 0.29291 10.3247C-0.0976367 10.7153 -0.0976367 11.3484 0.29291 11.7389L5.60518 17.0511C5.99557 17.4416 6.62916 17.4413 7.01939 17.0511L19.7071 4.36338C20.0977 3.97287 20.0976 3.33971 19.7071 2.94916Z"
                        fill="#1E9600"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_304_3457">
                        <rect width="20" height="20" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                  {/* Cross */}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="15"
                    height="15"
                    viewBox="0 0 15 15"
                    fill="none"
                  >
                    <g clip-path="url(#clip0_304_3460)">
                      <path
                        d="M0.972154 15.0119C0.723375 15.0119 0.474415 14.9167 0.285086 14.7272C-0.0950287 14.3472 -0.0950287 13.733 0.285086 13.353L13.3408 0.297156C13.7208 -0.0827761 14.335 -0.0827761 14.715 0.297156C15.095 0.677089 15.095 1.29136 14.715 1.67129L1.65922 14.7272C1.56915 14.8176 1.46207 14.8893 1.34415 14.9382C1.22623 14.9871 1.0998 15.0121 0.972154 15.0119Z"
                        fill="#F44336"
                      />
                      <path
                        d="M14.0279 15.0119C13.7791 15.0119 13.5303 14.9167 13.3408 14.7272L0.285086 1.67129C-0.0950287 1.29136 -0.0950287 0.677043 0.285086 0.297156C0.665019 -0.0827761 1.27911 -0.0827761 1.65922 0.297156L14.715 13.353C15.095 13.733 15.095 14.3473 14.715 14.7272C14.5255 14.9176 14.2767 15.0119 14.0279 15.0119Z"
                        fill="#F44336"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_304_3460">
                        <rect width="15" height="15" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default CustomMultiTable;
